import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { getDocs, getDoc, doc } from "firebase/firestore";
import { useState } from "react";
import { db } from "../../../Firebase/Firebase";

const Inside = ({ id, chatId }) => {
  const chatRef = doc(db, "support", `${chatId}`, "support_chat", `${id}`);
  const [message, setmessage] = useState("");

  useEffect(() => {
    const getData = async () => {
      const d = (await getDoc(chatRef)).data();
      setmessage(d);
    };
    getData();
  }, []);

  return (
    <div>
      <Typography>{message?.msg}</Typography>
    </div>
  );
};

export default Inside;
